module.exports = __webpack_public_path__ + "img/ivy_house_logo_white.5189841c.png";